import axios from 'axios';

const state = {
    posterImage: '/streamon.png',
  };
  
  const mutations = {
    setImg(state, url) {
        state.posterImage = url;
      },
  };
  
  const actions = {
    async updateImg({ commit, rootState }, assetId) {

        const apiPreUrl = rootState.url.apiPreUrl;
        // commit('setImg', assetId);
        try {
            const response = await axios.post(apiPreUrl + '/api/getPosterImage', { id: assetId });

            // console.log("==> ", response.data)

            if(response.data == null || response.data == ''){
              console.log("기본img")
              commit('setImg', '/streamon.png');
            }
            else {
              commit('setImg', response.data);
            }
          } catch (error) {
            console.error('Error => ', error);
          }
      },
  };
  
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };
